const externalLinks = {
  GOOGLE_AUTHENTICATOR_APP_STORE_URL:
    'https://apps.apple.com/us/app/google-authenticator/id388497605',
  GOOGLE_AUTHENTICATOR_GOOGLE_PLAY_URL:
    'https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2',
  AUTHY_URL: 'https://authy.com',
  TELEGRAM_SUPPORT_BOT_URL: 'https://t.me/amlbot_support_bot',
  MESSENGER_SUPPORT_URL: 'https://www.facebook.com/messages/t/CryptoAMLSafe',
  OLD_SERVICE_URL: 'https://old.amlbot.com',
  RISKS_SERVICE_URL: 'https://amlbot.com/what-do-we-analyze',
  API_DOC_URL: 'https://docs.amlbot.com/webApi/introduction',
  SERVICE_POLICY_URL: 'https://amlbot.com/privacy-policy',
  HOW_TO_FIND_TXID_URL:
    'https://blog.amlbot.com/how-to-find-txid-transaction-hash/',
  KOLO_PROMO_URL: 'https://promo.kolo.xyz/aml_bot',
};

export default externalLinks;
